exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vertical-select-image .element {\n  padding: 10px 30px;\n  cursor: pointer;\n  margin: 20px;\n  border: 1px solid #ccc;\n  display: block; }\n  .vertical-select-image .element.active, .vertical-select-image .element:hover {\n    background-color: #000;\n    color: #fff; }\n  .vertical-select-image .element img {\n    max-width: 80px;\n    height: 80px; }\n  .vertical-select-image .element .description {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    margin-left: 20px; }\n  .vertical-select-image .element .prix {\n    -ms-flex-item-align: end;\n        align-self: flex-end; }\n  .vertical-select-image .element .title {\n    text-align: center;\n    width: 100%;\n    display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Quentin/projets/kontractor/src/app/components/form/vertical-select-image/vertical-select-image.component.scss
// module id = ../../../../../src/app/components/form/vertical-select-image/vertical-select-image.component.scss
// module chunks = main